import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL + "livechat/";

export const addAttachment = async (payload) => {
  try {
    const response = await axios.post(`${apiUrl}addattachment`, payload);
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API addAttachment: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const closeLiveChatMessage = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}closelivechatmessage`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API closeLiveChatMessage: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const createTicket = async (payload) => {
  try {
    const response = await axios.post(`${apiUrl}createticket`, payload);
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API createTicket: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const endLiveChatSession = async (payload) => {
  try {
    const response = await axios.post(`${apiUrl}endlivechatsession`, payload);
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API endLiveChatSession: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getDetails = async (chatListID) => {
  try {
    const response = await axios.get(
      `${apiUrl}getdetails?chatlistid=${chatListID}`
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getDetails: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getMessageList = async (chatListID, page = 1) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getMessageList?chatlistid=${chatListID}&page=${page}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getMessageList: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getSettings = async (liveChatID) => {
  try {
    const response = await axios.get(
      `${apiUrl}getsettings?livechatid=${liveChatID}`
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getSettings: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const sendLiveChatMessage = async (payload) => {
  try {
    const response = await axios.post(`${apiUrl}sendLiveChatMessage`, payload);
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API sendLiveChatMessage: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const uploadFile = async (payload) => {
  try {
    const response = await axios.post(`${apiUrl}uploadfile`, payload);
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API uploadFile: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};
